"use client";

import Image from "next/image";
import { Button } from "@/components/ui/button";
import React from "react";
import { formatPrice } from "@/lib/utils";
import Link from "next/link";
import { getMarketplaceUrl } from "@/lib/marketplace-utils";

const ShopWith: React.FC = () => {
  const products = [
    {
      name: "ONYX LUXE SOFA",
      price: 285000,
      image: "/assets/images/Onyx_image1.png",
    },
    {
      name: "ONYX VISTA TV",
      price: 195000,
      image: "/assets/images/Onyx_image2.png",
    },
    {
      name: "ONYX VISTA TV",
      price: 195000,
      image: "/assets/images/Onyx_image3.png",
    },
  ];

  const marketPlaceIsReady = process.env.NEXT_PUBLIC_MARKETPLACE_FEATURE_FLAG === "true";
  return (
    <div className='min-h-100vh font-yellix p-0 pb-[8rem] md:pb-[4rem] lg:p-0 lg:pt-[2.6rem] lg:pb-[3.9rem]'>
      {/* Header Section */}
      <div className='mb-16 flex flex-col items-center md:mb-8 lg:mb-8 lg:flex-row lg:justify-between'>
        <div className='text-center lg:text-left'>
          <h1 className='text-text-title mb-2 text-base font-semibold md:text-[20px] md:font-normal lg:text-[26px]'>
            Everyday essentials, secured
            <span className='text-link-primary'>.</span>
          </h1>
          <p className='text-text-title text-sm font-medium md:font-normal'>
            The Onyx experience, designed to safeguard your needs
          </p>
        </div>
        <Link href={getMarketplaceUrl("/shop")}>
          <Button className='font-yellix mt-5 hidden gap-0 rounded-full px-8 text-sm font-semibold duration-300 ease-in-out hover:scale-95 md:block md:h-[50px] md:w-[187px] lg:mt-0'>
            <span>
              Shop with Onyx
              <span className='text-link-primary'>.</span>
            </span>
          </Button>
        </Link>
      </div>

      {/* Image Grid Section */}
      <div className='mx-auto grid w-2/3 grid-cols-1 gap-24 md:w-auto md:grid-cols-3 md:gap-4'>
        {products.map((product, index) => (
          <div key={index} className='relative h-88 w-full shadow-lg md:h-[400px] md:overflow-hidden lg:h-[650px]'>
            <Image
              src={product.image}
              alt={product.name}
              fill
              priority
              className='object-cover transition-transform duration-600 hover:scale-110'
            />
            <Button
              className={`absolute right-1/2 -bottom-12 h-[28px] w-[155px] max-w-3/4 translate-x-1/2 gap-7 rounded-full text-[10px] font-semibold capitalize md:bottom-12 md:h-[48px] md:w-auto md:max-w-full md:px-4 md:text-xs lg:px-8 lg:text-[13px] 2xl:h-14 2xl:text-base ${marketPlaceIsReady ? "block" : "hidden"}`}
            >
              <span className=''>{product.name}</span>
              <span className=''>{formatPrice(product.price)}</span>
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShopWith;
